<template src="./index.html"></template>

<script>
import {
	getdata
} from './data.js';
export default {
	data() {
		return {
			qrCode: "",
			refreshDate: "",
			kpr: "",
			smsCode: ""
		};
	},
	mounted() {
	},
	created() {
		this.getSmsCode()
	},
	methods: {
		//初始化验证码
		getSmsCode() {
			var token = localStorage.getItem('token')
			if (token == "" || token == null) {
				localStorage.setItem('token', " ");
			}
			const formData = new FormData()
			formData.append('refresh', false)
			let requestUrl = this.getRequestParam()
			formData.append('id', requestUrl.id)
			this.$https.fetchPost('/rpa/authentication/getPhoneMessage/v2', formData).then(res => {
				if (res.data.code == '200') {
					this.refreshDate = res.data.data.msgTime;
					this.kpr = res.data.data.loginAccount;
				} else {
					this.$message.error(res.data.message);
				}

			})
		},
		//发送验证码
		sendSmsCode() {
			if (!this.$route.query.id) {
				this.$message.error("查询验证码信息错误：找不到身份验证记录");
				return
			}
			var token = localStorage.getItem('token')
			if (token == "" || token == null) {
				localStorage.setItem('token', " ");
			}
			const formData = new FormData()
			formData.append('id', this.$route.query.id)
			formData.append('refresh', true)
			this.$https.fetchPost('/rpa/authentication/getPhoneMessage/v2', formData).then(res => {
				if (res.data.code == 200) {
					this.$message.success("验证码发送成功");
					this.refreshDate = res.data.data.msgTime;
					this.kpr = res.data.data.loginAccount
				} else {
					this.$message.error(res.data.message);
				}
			})

		},
		//提交验证码
		submitSmsCode() {
			if (!this.$route.query.id) {
				this.$message.error("查询验证码信息错误：找不到身份验证记录");
				return
			}
			if (this.smsCode == "") {
				this.$message.error("请输入验证码");
				return
			}
			const formData = new FormData()
			formData.append('id', this.$route.query.id)
			formData.append('smsCode', this.smsCode)
			this.$https.fetchPost('/rpa/authentication/authCodeLogin/v2', formData).then(res => {
				if (res.data.code == '200') {
					this.$message.success("验证成功");
				} else {
					this.$message.error("验证码错误或失效！");
				}
			})
		},
		getDate() {
			let date = new Date();
			return date.getFullYear() + '-' +
				('0' + (date.getMonth() + 1)).slice(-2) + '-' +
				('0' + date.getDate()).slice(-2) + ' ' +
				('0' + date.getHours()).slice(-2) + ':' +
				('0' + date.getMinutes()).slice(-2) + ':' +
				('0' + date.getSeconds()).slice(-2);

		},
		getRequestParam() {   //  获取请求后面的参数
			var requestParam = new Object();
			if (location.href.indexOf('?') != -1) {
				var url = location.href.substring(location.href.indexOf('?')); //获取url中"?"符后的字串
				var str = url.substr(1);
				let strs = str.split("&");
				for (var i = 0; i < strs.length; i++) {
					requestParam[strs[i].split("=")[0]] = decodeURI(strs[i].split("=")[1]); //获取中文参数转码<span style="font-family: Arial, Helvetica, sans-serif;">decodeURI</span>，（unescape只针对数字，中文乱码)
				}
			}
			return requestParam;
		},
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>